/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as STokenRouteImport } from './routes/s/$token'
import { Route as FTokenRouteImport } from './routes/f/$token'
import { Route as AuthenticatedManageDataRouteImport } from './routes/_authenticated/manage-data'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedTrashIndexRouteImport } from './routes/_authenticated/trash/index'
import { Route as AuthenticatedCollectionsIndexRouteImport } from './routes/_authenticated/collections/index'
import { Route as AuthenticatedBrowseIndexRouteImport } from './routes/_authenticated/browse/index'
import { Route as AuthenticatedCollectionsCollectionIdRouteImport } from './routes/_authenticated/collections/$collectionId'
import { Route as AuthenticatedBrowseAssetIdRouteImport } from './routes/_authenticated/browse/$assetId'

const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const FTokenRoute = FTokenRouteImport.update({
  id: '/f/$token',
  path: '/f/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedManageDataRoute = AuthenticatedManageDataRouteImport.update({
  id: '/manage-data',
  path: '/manage-data',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTrashIndexRoute = AuthenticatedTrashIndexRouteImport.update({
  id: '/trash/',
  path: '/trash/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCollectionsIndexRoute =
  AuthenticatedCollectionsIndexRouteImport.update({
    id: '/collections/',
    path: '/collections/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBrowseIndexRoute =
  AuthenticatedBrowseIndexRouteImport.update({
    id: '/browse/',
    path: '/browse/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCollectionsCollectionIdRoute =
  AuthenticatedCollectionsCollectionIdRouteImport.update({
    id: '/collections/$collectionId',
    path: '/collections/$collectionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBrowseAssetIdRoute =
  AuthenticatedBrowseAssetIdRouteImport.update({
    id: '/browse/$assetId',
    path: '/browse/$assetId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/home': typeof AuthenticatedHomeRoute
  '/manage-data': typeof AuthenticatedManageDataRoute
  '/f/$token': typeof FTokenRoute
  '/s/$token': typeof STokenRoute
  '/browse/$assetId': typeof AuthenticatedBrowseAssetIdRoute
  '/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdRoute
  '/browse': typeof AuthenticatedBrowseIndexRoute
  '/collections': typeof AuthenticatedCollectionsIndexRoute
  '/trash': typeof AuthenticatedTrashIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/home': typeof AuthenticatedHomeRoute
  '/manage-data': typeof AuthenticatedManageDataRoute
  '/f/$token': typeof FTokenRoute
  '/s/$token': typeof STokenRoute
  '/browse/$assetId': typeof AuthenticatedBrowseAssetIdRoute
  '/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdRoute
  '/browse': typeof AuthenticatedBrowseIndexRoute
  '/collections': typeof AuthenticatedCollectionsIndexRoute
  '/trash': typeof AuthenticatedTrashIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/manage-data': typeof AuthenticatedManageDataRoute
  '/f/$token': typeof FTokenRoute
  '/s/$token': typeof STokenRoute
  '/_authenticated/browse/$assetId': typeof AuthenticatedBrowseAssetIdRoute
  '/_authenticated/collections/$collectionId': typeof AuthenticatedCollectionsCollectionIdRoute
  '/_authenticated/browse/': typeof AuthenticatedBrowseIndexRoute
  '/_authenticated/collections/': typeof AuthenticatedCollectionsIndexRoute
  '/_authenticated/trash/': typeof AuthenticatedTrashIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/no-access'
    | '/home'
    | '/manage-data'
    | '/f/$token'
    | '/s/$token'
    | '/browse/$assetId'
    | '/collections/$collectionId'
    | '/browse'
    | '/collections'
    | '/trash'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/no-access'
    | '/home'
    | '/manage-data'
    | '/f/$token'
    | '/s/$token'
    | '/browse/$assetId'
    | '/collections/$collectionId'
    | '/browse'
    | '/collections'
    | '/trash'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/no-access'
    | '/_authenticated/home'
    | '/_authenticated/manage-data'
    | '/f/$token'
    | '/s/$token'
    | '/_authenticated/browse/$assetId'
    | '/_authenticated/collections/$collectionId'
    | '/_authenticated/browse/'
    | '/_authenticated/collections/'
    | '/_authenticated/trash/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  NoAccessRoute: typeof NoAccessRoute
  FTokenRoute: typeof FTokenRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/f/$token': {
      id: '/f/$token'
      path: '/f/$token'
      fullPath: '/f/$token'
      preLoaderRoute: typeof FTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/manage-data': {
      id: '/_authenticated/manage-data'
      path: '/manage-data'
      fullPath: '/manage-data'
      preLoaderRoute: typeof AuthenticatedManageDataRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/trash/': {
      id: '/_authenticated/trash/'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AuthenticatedTrashIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/collections/': {
      id: '/_authenticated/collections/'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof AuthenticatedCollectionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/browse/': {
      id: '/_authenticated/browse/'
      path: '/browse'
      fullPath: '/browse'
      preLoaderRoute: typeof AuthenticatedBrowseIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/collections/$collectionId': {
      id: '/_authenticated/collections/$collectionId'
      path: '/collections/$collectionId'
      fullPath: '/collections/$collectionId'
      preLoaderRoute: typeof AuthenticatedCollectionsCollectionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/browse/$assetId': {
      id: '/_authenticated/browse/$assetId'
      path: '/browse/$assetId'
      fullPath: '/browse/$assetId'
      preLoaderRoute: typeof AuthenticatedBrowseAssetIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedManageDataRoute: typeof AuthenticatedManageDataRoute
  AuthenticatedBrowseAssetIdRoute: typeof AuthenticatedBrowseAssetIdRoute
  AuthenticatedCollectionsCollectionIdRoute: typeof AuthenticatedCollectionsCollectionIdRoute
  AuthenticatedBrowseIndexRoute: typeof AuthenticatedBrowseIndexRoute
  AuthenticatedCollectionsIndexRoute: typeof AuthenticatedCollectionsIndexRoute
  AuthenticatedTrashIndexRoute: typeof AuthenticatedTrashIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedManageDataRoute: AuthenticatedManageDataRoute,
  AuthenticatedBrowseAssetIdRoute: AuthenticatedBrowseAssetIdRoute,
  AuthenticatedCollectionsCollectionIdRoute:
    AuthenticatedCollectionsCollectionIdRoute,
  AuthenticatedBrowseIndexRoute: AuthenticatedBrowseIndexRoute,
  AuthenticatedCollectionsIndexRoute: AuthenticatedCollectionsIndexRoute,
  AuthenticatedTrashIndexRoute: AuthenticatedTrashIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  NoAccessRoute: NoAccessRoute,
  FTokenRoute: FTokenRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
